import { RuntimeNotImplementedError } from "@/domains/errors";

export const _controlFlowLogicNotImplementedError = ({ message }: { message: string }) => {
  throw new RuntimeNotImplementedError({
    message,
  });
};
